import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sbpro-layout-landing',
  templateUrl: './sbpro-layout-landing.component.html',
  styleUrls: ['./sbpro-layout-landing.component.scss']
})
export class SbproLayoutLandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
